const globals = {
  mapboxAccessToken: 'pk.eyJ1Ijoid3dlZ2Vua2UiLCJhIjoiY2t3NWl5eWRlMTZocTJvbW5xenFlcDFlMCJ9.TQud3faSsauFW-7URATL4Q',
  payPalClientId_TEST: 'AcK5lVZe3A2GpbPCYQyYgiaBkXO9qOkpmeSr8AKpV6yt-t485mJmTKFgZC2NCBAp3elU-V-y4xdII_gi',
  payPalClientId: 'AZa_UNPut5Kt-pzVREd5o1_xRKy0vjid0vZm_pW2hTks2P2j7BxoAVcXMbCcJWsE5SU1O5Aq0ljAetU0',
  STREETS_STYLE: 'mapbox://styles/mapbox/streets-v12',
  SATELLITE_STYLE: 'mapbox://styles/mapbox/satellite-streets-v12'
};

export default globals;